module.exports = "pegasus/assets/background-patterns/theme5_theme.gif";